export default "__VITE_ASSET__D70ONq1w__"